import { TRecommendation } from '../../types/recommendation';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ERecommendationActionTypes {
  Pending = 'recommendations/fetch/pending',
  Fulfilled = 'recommendations/fetch/fulfilled',
  Rejected = 'recommendations/fetch/rejected',
  MorePending = 'recommendations/fetchMore/pending',
  MoreFulfilled = 'recommendations/fetchMore/fulfilled',
  MoreRejected = 'recommendations/fetchMore/rejected',
  ToggleFavorite = 'recommendations/toggleFavorite',
}

export interface IRecommendationFulfilledPayload {
  data: TRecommendation[];
  hasMore: boolean;
}

export interface IRecommendationMoreFulfilledPayload {
  data: TRecommendation[];
  hasMore: boolean;
  page: number;
}

export interface IRecommendationToggleFavoritePayload {
  offerId: number;
  isFavorite: boolean;
}

export type TRecommendationPending = ITypedReduxAction<ERecommendationActionTypes.Pending>;
export type TRecommendationFulfilled = ITypedReduxAction<
  ERecommendationActionTypes.Fulfilled,
  IRecommendationFulfilledPayload
>;
export type TRecommendationRejected = ITypedReduxAction<ERecommendationActionTypes.Rejected>;

export type TRecommendationMorePending = ITypedReduxAction<ERecommendationActionTypes.MorePending>;
export type TRecommendationMoreFulfilled = ITypedReduxAction<
  ERecommendationActionTypes.MoreFulfilled,
  IRecommendationMoreFulfilledPayload
>;
export type TRecommendationMoreRejected = ITypedReduxAction<ERecommendationActionTypes.MoreRejected>;

export type TRecommendationToggleFavorite = ITypedReduxAction<
  ERecommendationActionTypes.ToggleFavorite,
  IRecommendationToggleFavoritePayload
>;

export type TRecommendationActions =
  | TRecommendationPending
  | TRecommendationFulfilled
  | TRecommendationRejected
  | TRecommendationMorePending
  | TRecommendationMoreFulfilled
  | TRecommendationMoreRejected
  | TRecommendationToggleFavorite;
